export class Header {
  public render(): string {
    return `
      <header class="relative border-b border-primary-100/80 dark:border-gray-800 bg-white/90 dark:bg-gray-900/90 backdrop-blur-md shadow-sovran dark:shadow-none">
        <div class="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-primary-300/40 to-transparent dark:via-primary-600/20" aria-hidden="true"></div>
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="flex justify-between items-center h-[4.25rem]">
            <a href="/" class="flex items-center gap-4 group focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 rounded-lg">
              <img
                src="/sovranai_logo.svg"
                alt="Sovran AI"
                class="h-9 sm:h-10 w-auto max-w-[min(100%,280px)] object-contain object-left transition-transform duration-200 group-hover:scale-[1.02]"
                width="280"
                height="49"
              />
              <div class="hidden sm:block border-l border-primary-100 dark:border-gray-700 pl-4">
                <p class="text-xs font-medium text-primary-600 dark:text-primary-400 tracking-wide uppercase">One-time secret</p>
                <p class="text-sm text-slate-500 dark:text-slate-400 mt-0.5">Secure sharing, single read</p>
              </div>
            </a>

            <div class="flex items-center gap-2">
              <button
                type="button"
                class="p-2.5 rounded-xl text-slate-500 hover:text-primary-600 hover:bg-primary-50 dark:text-slate-400 dark:hover:text-primary-300 dark:hover:bg-gray-800 transition-colors"
                data-action="toggle-theme"
                title="Toggle theme"
                aria-label="Toggle theme"
              >
                <svg class="w-5 h-5 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path class="pointer-events-none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </header>
    `
  }
}
